import { ComponentProps, ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";

const ToggleButton = styled(MuiToggleButton)(() => ({
}));


export interface ToolbarButtonProps extends ComponentProps<typeof ToggleButton> {
    tooltip?: string;
    children?: ReactNode;
}

export function ToolbarButton(props: ToolbarButtonProps) {

    const {
        tooltip,
        children,
        "aria-label": ariaLabel,
        size = 'small',
        ...toggleButtonProps
    } = props;

    return (
        <Tooltip title={tooltip}>
            <span style={{ display: 'inline-block' }}>
                <ToggleButton size={size} aria-label={ariaLabel ?? tooltip} {...toggleButtonProps}>
                    {/* {typeof children === 'string' && (<FontIcon>{children}</FontIcon>)}
                    {typeof children !== 'string' && (children)} */}
                    {children}
                </ToggleButton>
            </span>
        </Tooltip>
    );
}

export default ToolbarButton;